export default __webpack_public_path__ + "static/media/image-main-1-w@3x.927ae679.webp";